export default {
  data() {
    return {
      portfolios: [
        {
          id: 1,
          img: "/assets/images/portfolio/smo-logo-1.png",
          title: "SCHOOLMATE ONLINE",
          project: "School Management System",
          client: "Tigernethost",
          language: "PHP, Laravel, HTML, CSS, Javascript, Vue",
          preview: "www.schoolmate-online.net",
          previewLink: "https://www.schoolmate-online.net/",
          alt: "Portfolio",
          description1: "SchoolMATE Online is a fully-integrated school management system that equips institutions with improved IT infrastructure and efficient information system. It automates processes from online admission to accounting and payroll, and even asset management for a very affordable value compared to any similar commercial-based system in the Philippines",
          description2: "",
          description3: "",
          description4: "",
        },
        {
          id: 2,
          img: "/assets/images/portfolio/one-pampanga-logo-1.png",
          title: "ONE PAMPANGA",
          project: "Business Directory Listing",
          client: "Tigernethost",
          language: "PHP, Laravel, HTML, CSS, Javascript, Vue",
          preview: "www.onepampanga.com",
          previewLink: "https://onepampanga.com/",
          alt: "One Pampanga",
          description1: "One Pampanga is an online directory listing. Your business information including its product and services may be posted in our website which increase your business' searchability",
          description2: "",
          description3: "",
          description4: "",
        },
        {
          id: 3,
          img: "/assets/images/portfolio/one-zambales-logo-horizontal.png",
          title: "ONE ZAMBALES",
          project: "Business Directory Listing",
          client: "Tigernethost",
          language: "Vue, HTML, CSS, Javascript",
          preview: "www.onezambales.com",
          previewLink: "https://onezambales.com/",
          alt: "One Zambales",
          description1: "One Zambales is an online directory listing. Your business information including its product and services may be posted in our website which increase your business' searchability",
          description2: "",
          description3: "",
          description4: "",
        },
        // {
        //   id: 4,
        //   img: "/assets/images/portfolio/project-4.jpg",
        //   title: "DRIBBBLE PROJECT",
        //   project: "Project Shoot",
        //   client: "dribbble",
        //   language: "React",
        //   preview: "www.dribbble.com",
        //   previewLink: "https://dribbble.com/ib-themes",
        //   alt: "Portfolio",
        // },
        // {
        //   id: 5,
        //   img: "/assets/images/portfolio/project-5.jpg",
        //   title: "BEHANCE PROJECT",
        //   project: "Live Shoot",
        //   client: "Behance",
        //   language: "React,Bootstrap",
        //   preview: "www.behance.com",
        //   previewLink: "https://www.behance.net/ib-themes",
        //   alt: "Portfolio",
        // },
        // {
        //   id: 6,
        //   img: "/assets/images/portfolio/project-6.jpg",
        //   title: "SAAS PROJECT",
        //   project: "Web Application",
        //   client: "Themeforest",
        //   language: "HTML, CSS, ReactJs",
        //   preview: "www.themeforest.com",
        //   previewLink: "https://themeforest.net/item/deski-saas-software-react-template/33799794",
        //   alt: "Portfolio",
        // },
        // {
        //   id: 7,
        //   img: "/assets/images/portfolio/project-7.jpg",
        //   title: "MOCKUP PROJECT",
        //   project: "Website",
        //   client: "Pexels",
        //   language: "Adobe Photoshop",
        //   preview: "www.pexels.com",
        //   previewLink: "https://www.pexels.com/",
        //   alt: "Portfolio",
        // },
        // {
        //   id: 8,
        //   img: "/assets/images/portfolio/project-8.jpg",
        //   title: "FACEBOOK PROJECT",
        //   project: "Shoot",
        //   client: "Facebook",
        //   language: "Reactjs",
        //   preview: "www.facebook.com",
        //   previewLink: "https://www.facebook.com/ibthemes",
        //   alt: "Portfolio",
        // },
        // {
        //   id: 9,
        //   img: "/assets/images/portfolio/project-9.jpg",
        //   title: "LINKEDIN PROJECT",
        //   project: "Website",
        //   client: "Linkedin",
        //   language: "Vue 3",
        //   preview: "www.linkedin.com",
        //   previewLink: "https://www.linkedin.com/in/ib-themes-company-469408207/recent-activity/shares/",
        //   alt: "Portfolio",
        // },
      ],
    };
  },
};
